import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "school-group-container"
}
const _hoisted_2 = { class: "form-card-tabs-container px-44 pt-10" }
const _hoisted_3 = { class: "text-gray-700 text-2xl font-normal border-b-[1px] border-gray-300 pb-3" }
const _hoisted_4 = { class: "columns-2 mt-6" }
const _hoisted_5 = { class: "text-dark-grey font-medium text-2xl my-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_11 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex justify-between items-center mt-4" }
const _hoisted_14 = { class: "h-5 w-5 shrink-0 text-gray-600 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_15 = { class: "font-semibold text-sm text-gray-600" }
const _hoisted_16 = { class: "flex justify-between mt-6" }
const _hoisted_17 = { class: "h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex justify-between mt-4" }
const _hoisted_21 = { class: "h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_22 = { class: "columns-2 mt-6" }
const _hoisted_23 = { class: "columns-2 mt-6" }
const _hoisted_24 = { class: "text-gray-700 font-medium text-sm" }
const _hoisted_25 = {
  key: 0,
  class: "absolute z-10 top-[100%] font-normal text-sm pt-1"
}
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = {
  key: 0,
  "data-testid": "region-guard",
  role: "alert",
  class: "mt-4 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900"
}
const _hoisted_28 = { class: "columns-2 mt-6" }
const _hoisted_29 = { class: "columns-2 mt-6" }
const _hoisted_30 = { class: "mt-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "text-dark-grey font-semibold text-xl my-6" }, "New License", -1)
const _hoisted_32 = { class: "grid grid-cols-4 gap-x-4 gap-y-8" }
const _hoisted_33 = { class: "text-dark-grey font-medium text-2xl my-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 2,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_39 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "flex justify-between items-center mt-4" }
const _hoisted_42 = { class: "h-5 w-5 shrink-0 text-gray-600 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_43 = { class: "font-semibold text-sm text-gray-600" }
const _hoisted_44 = { class: "flex items-end justify-end mt-3" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "font-semibold text-sm" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 0,
  class: "form-card-tabs-container pt-10"
}
const _hoisted_50 = { class: "text-gray-700 text-2xl font-normal border-b-[1px] border-gray-300 pb-3" }
const _hoisted_51 = { class: "columns-2 mt-6" }
const _hoisted_52 = { class: "flex gap-4" }
const _hoisted_53 = { class: "flex gap-3 justify-end items-center h-14 pt-8" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "flex items-end justify-end mt-3" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "font-semibold text-sm" }
const _hoisted_59 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "py-8 relative" }
const _hoisted_62 = { class: "flex flex-col gap-5 justify-center items-center relative" }
const _hoisted_63 = { class: "absolute right-5 top-[-1rem]" }
const _hoisted_64 = { class: "relative" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "text-base font-semibold" }
const _hoisted_67 = { class: "text-gray-600 text-sm font-normal" }
const _hoisted_68 = { class: "flex gap-3 w-full px-3 mt-4" }

import { computed, ref, watch } from 'vue';
import { useAdminStore } from '@/stores/adminStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { useFilterStore } from '@/stores/filterStore';
import i18n from '@/plugins/i18n';
import { countryOptions } from '@/helper/countries';
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/20/solid";
import { TrashIcon, XMarkIcon, PencilIcon } from "@heroicons/vue/24/outline";
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import omit from "lodash/omit";
import { CheckCircleIcon, XCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOption,
    ComboboxOptions,
} from "@headlessui/vue";
import { FormKitNode } from '@formkit/core';
import { Admin } from '@/interfaces/admin.interface';
import { useSchoolGroupStore } from '@/stores/schoolGroupsStore';
import { useProductStore } from '@/stores/productStore';
import { School } from '@/interfaces/school.interface';
import { NewLicenseFormData } from '@/interfaces/license.interface';
import moment from 'moment';
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'
import { useSubjectStore } from '@/stores/subjectStore';
import isEqual from 'lodash/isEqual';
import { useUserStore } from '@/stores/userStore';
import { deploymentRegion, wrongRegionFor } from '@/lib/region-country';

interface SearchOption {
    id: string;
    name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleSchoolsComponent',
  emits: ["updateValue"],
  setup(__props, { emit: emits }) {

const { t } = useI18n();

const schoolStore = useSchoolStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const schoolGroupStore = useSchoolGroupStore();
const productStore = useProductStore();
const subjectStore = useSubjectStore();
// The subject list is loaded on sign-in; if this form opens before it has
// arrived (or after it failed), load it here rather than offer no subjects.
if (!subjectStore.getSubjects.length) {
  subjectStore.fetchSubjects().catch(() => undefined);
}

const selectedOption = ref<SearchOption | null>(null);
const showRequired = ref(false);
const buttonIsDisabled = ref(false);
const searchQuery = ref("");
const placeholder = ref(i18n.global.t("internal_tools.select").toString());
const updateSuccess = ref(false);
const responseMessage = ref("");
const newAdmins = ref<Admin[]>([]);
const newSchoolGroupAdmins = ref<Admin[]>([]);
const step = ref(1);
const showEditFields = ref(false);
const schoolToDelete = ref(null);
const isModalOpen = ref(false);
const schoolName = ref("");

const schoolsCount = ref(0);
const targetBlock = ref<HTMLElement | null>(null);
const showErrorMessage = ref(false);
const schoolLicenses = ref<any>({});
const scrollUp = ref<HTMLElement | null>(null);

const schoolsList = ref([]) as any;

const newSchoolGroupAdmin = ref({
    firstName: "",
    lastName: "",
    email: "",
    designation: "School Group Champion",
    status: "inactive",
    roles: [],
    phoneNumber: null,
    schoolGroup: "",
}) as any;

const newAdmin = ref({
    firstName: "",
    lastName: "",
    email: "",
    designation: "School Champion",
    status: "inactive",
    roles: [],
    phoneNumber: null,
}) as any;

const newSchoolGroup = ref({
    name: "",
    description: ""
});

const schoolObject = ref({
    name: "",
    domain: "",
    emisNumber: "",
    schoolGroup: "",
    academicYearStart: "",
    academicYearEnd: "",
    preferredLang: "",
    subjectsAvailable: [],
    location: {
        city: "",
        country: "",
        street: "",
    },
    admins: [] as Admin[],
    schoolGroupAdmins: [] as Admin[],
    schoolLicenseData: {
        type: 'annual',
        startDate: '',
        endDate: '',
        products: productStore.products.map(product => ({
            product: product._id,
            maxSeats: 0,
            seatsUsed: 0,
        }))
    } as NewLicenseFormData
}) as any;

// A school is created in the region its country belongs to. Checked here as
// well as by dashboard-api, so nothing is created before the refusal.
const userStore = useUserStore();
const here = ref<string | null>(null);
deploymentRegion().then(region => {
  here.value = region;
});
const wrongRegion = computed(() => wrongRegionFor(schoolObject.value?.location?.country, here.value));
const switchRegion = () => userStore.forceRegionReauth();


const licenseStartDateValidationRule = computed(() => {
    return `required|date_after:${moment().format('YYYY-MM-DD')}`;
});

schoolObject.value.subjectsAvailable = "";

// subjects options for FormKit select
const subjectsOptions = computed(() => {
  const subjects = subjectStore.getSubjects;

  const options = [];

  options.push({
    label: i18n.global.t("internal_tools.form.select_subject"),
    value: "",
    attrs: { disabled: true }
  });

  // Add individual subjects
  subjects.forEach(subject => {
    options.push({
      label: subject.name,
      value: [subject.id],
    });
  });

  // Add combined option if at least two subjects exist
  if (subjects.length >= 2) {
    const combinedLabel = `${subjects[0].name} and ${subjects[1].name}`;
    const combinedValue = [subjects[0].id, subjects[1].id];

    options.push({
      label: combinedLabel,
      value: combinedValue,
    });
  }

  return options;
});

const notifySuccessAddSchoolGroup = () => {
  showToast({
    text: responseMessage.value,
    type: 'success',
    icon: CheckCircleIcon,
  })
};

const notifyErrorAddSchoolGroup = () => {
  showToast({
    text: t('internal_tools.multiple_schools_component.create_license'),
    type: 'error',
    icon: ExclamationCircleIcon,
  })
};

const previewStep = () => {
    emits("updateValue", false);
};

const showDeleteModal = (index: any) => {
    schoolToDelete.value = index;
    isModalOpen.value = true;

    //assign name to variable
    schoolName.value = schoolsList.value[index].name;
};

const confirmDelete = () => {
    if (schoolToDelete.value !== null) {
        deleteSchool(schoolToDelete.value);
    }
    isModalOpen.value = false;
    schoolToDelete.value = null;
};

const cancelDelete = () => {
    isModalOpen.value = false;
    schoolToDelete.value = null;
};

const deleteSchool = (index: any) => {
    schoolsList.value.splice(index, 1);
};

// Computed filtered options based on `searchQuery`
const filteredOptions = computed(() =>
    searchQuery.value === ""
        ? countryOptions
        : countryOptions.filter((o) =>
            o.name.toLowerCase().includes(searchQuery.value.toLowerCase())
        )
);

// Computed property for FormKit select options
const localeOptions = computed(() =>
    schoolStore.getLocales.map(locale => ({
        label: locale.name,
        value: locale.code
    }))
);

const championNames = computed(() => {
    return schoolsList.value.map((school: any) => {
        if (school.admins.length === 0) {
            return i18n.global.t("internal_tools.multiple_schools_component.no_champion").toString();
        }

        const firstAdmin = school.admins[0];
        return `${firstAdmin.firstName} ${firstAdmin.lastName}`;
    });
});

const editSchool = (index: number) => {
    const values = schoolsList.value[index];
    schoolObject.value = values;
    showEditFields.value = true;
    
    // scroll all the way to the top
    targetBlock.value?.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
};

const removeChampion = (index: number) => {
    newAdmins.value.splice(index, 1);
};

const removeChampionAfterEdit = (index: number) => {
    schoolObject.value.admins.splice(index, 1);
};

const removeSchoolGroupChampion = (index: number) => {
    newSchoolGroupAdmins.value.splice(index, 1);
};

const removeSchoolGroupAdminAfterEdit = (index: number) => {
    schoolObject.value.schoolGroupAdmins.splice(index, 1);
};

// Change coutry casing
const formatCountryName = (country: string) => {

    //check if the country is in the countryOptions
    const countryExist = countryOptions.find((o) => o.id === country);

    //if the country is not in the countryOptions, return the selectedOption value
    if (!countryExist) {
        return selectedOption.value?.name;
    }

    return country
        ? country
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ')
        : '';
}

const addSchoolToList = async () => {
    // Check if required fields are filled
    if (schoolObject.value.location.country.trim().length === 0) {
        showRequired.value = true;
        return;
    }

    if (wrongRegion.value) {
        return;
    }

    // Hide error message
    showErrorMessage.value = false;

    // Add admins to school object if they were created
    if (newAdmins.value.length >= 0) {
        newAdmins.value.forEach(admin => {
            // Check if all necessary fields are filled
            if (admin.firstName && admin.lastName && admin.email) {
                schoolObject.value.admins.push(admin);
            } else {
                console.log("Admin data is incomplete");
            }
        });
    }

    // Check if the school already exists in schoolsList based on name
    const existingSchoolIndex = schoolsList.value.findIndex(
        (school: School) => school.name === schoolObject.value.name
    );

    if (existingSchoolIndex !== -1) {
        // Replace the existing school with the updated data
        schoolsList.value[existingSchoolIndex] = { ...schoolObject.value };
        console.log(`Updated existing school: ${schoolObject.value.name}`);
    } else {
        // Add the new school to the list
        schoolsList.value.push({ ...schoolObject.value });
        console.log(`Added new school: ${schoolObject.value.name}`);
    }

    console.log("School OBJ: ", schoolObject.value);

    // Clear the form
    clearData();
};

// Create a new school group and schools
const handleNext = async () => {
    // Refuse before the group is created, or it would be left behind in the
    // wrong region when the server refuses its schools.
    if (schoolsList.value.some((school: School) => wrongRegionFor(school.location?.country, here.value))) {
        responseMessage.value = i18n.global.t('internal_tools.region_guard.message', {
            belongs: (wrongRegionFor(schoolsList.value.find((school: School) => wrongRegionFor(school.location?.country, here.value))?.location?.country, here.value) || '').toUpperCase(),
            here: (here.value || '').toUpperCase()
        }).toString();
        // Only reachable when the region was learned after the school was
        // added, so the inline banner (bound to the emptied form) is not up.
        showToast({
            text: responseMessage.value,
            type: 'error',
            icon: ExclamationCircleIcon,
        });
        return;
    }
    try {
        // Create a new school group
        const newGroupResponse = await schoolGroupStore.createSchoolGroup(newSchoolGroup.value);
        let schoolGroupObj = newGroupResponse;

        if (!newGroupResponse) {
            responseMessage.value = i18n.global.t("internal_tools.multiple_schools_component.school_group_not_created").toString();
            schoolsCount.value = 0;
            return;
        }

        // Add school group champions concurrently
        if (newSchoolGroupAdmins.value.length > 0) {
            const adminPromises = newSchoolGroupAdmins.value.map(async (admin:any) => {
                if (admin.firstName && admin.lastName && admin.email) {
                    admin.schoolGroup = newGroupResponse._id as string;
                    await schoolGroupStore.createNewAdmin(admin);
                } else {
                    console.log("Admin data is incomplete");
                }
            });

            await Promise.all(adminPromises);
        }

        let totalSchools = 0;

        for (const school of schoolsList.value) {
            // Extract month and day from academicYearStart and academicYearEnd
            const formatDate = (dateString: any) => {
                const dateParts = dateString.split('-');
                if (dateParts.length === 3) {
                    const month = dateParts[1];
                    const day = dateParts[2];
                    return `${month}-${day}`; // Return MM-DD
                }
                return dateString;
            };

            // Format the academicYearStart and academicYearEnd
            school.academicYearStart = formatDate(school.academicYearStart);
            school.academicYearEnd = formatDate(school.academicYearEnd);

            // Copy admins and schoolGroupAdmins
            newSchoolGroupAdmins.value = school.schoolGroupAdmins || [];
            newAdmins.value = school.admins || [];

            // Prepare the payload by removing empty fields and unwanted properties
            const preparedPayload = omit(
                omitBy(school, (value) => isEmpty(value) && typeof value === 'string'),
                ["schoolGroupAdmins", "admins"]
            );

            // Add the school group to the prepared payload
            preparedPayload.schoolGroup = schoolGroupObj._id as string;

            // Create a new school with the prepared payload
            const result = await schoolStore.createSchool(preparedPayload);

            if (result) {
                // Increment schools count and push to the group
                totalSchools++;
                schoolGroupObj.schools.push(result as School);

                // Add school champions concurrently
                if (Array.isArray(newAdmins.value) && newAdmins.value.length > 0) {
                    const adminPromises = newAdmins.value.map(async (admin: any) => {
                        if (admin.firstName && admin.lastName && admin.email) {
                            admin.school = result._id;
                            await adminStore.createNewAdmin(admin);
                        } else {
                            console.log("Admin data is incomplete");
                        }
                    });

                    await Promise.all(adminPromises);
                }

            } else {
                console.log(`${school.name} was not successfully created.`);
            }
        }

        // Determine pluralization
        const plural = totalSchools <= 1 ? '' : i18n.global.t("internal_tools.multiple_schools_component.plural").toString();
        const verb = totalSchools <= 1 ? i18n.global.t("internal_tools.multiple_schools_component.was").toString() : i18n.global.t("internal_tools.multiple_schools_component.were").toString();


        // Update response message after all operations are complete
        responseMessage.value = `
            ${i18n.global.t('internal_tools.multiple_schools_component.school_group_created', { groupName: newGroupResponse.name })}<br/>
            ${i18n.global.t('internal_tools.multiple_schools_component.schools_created', { totalSchools, plural, verb })}
        `;
        schoolsCount.value = totalSchools;
        updateSuccess.value = true;
        notifySuccessAddSchoolGroup();

        // Add school group and school to state
        schoolGroupStore.addSchoolGroup(schoolGroupObj);
        filterStore.addSchoolGroup(schoolGroupObj);

        // clear school list
        schoolsList.value = [];

        // Clear the form
        clearData();
    } catch (error) {
        console.error("An error occurred:", error);
        responseMessage.value = i18n.global.t("internal_tools.multiple_schools_component.error_message").toString();
        updateSuccess.value = false;
        notifyErrorAddSchoolGroup();
    }
};

const email_exists = async (node: FormKitNode): Promise<boolean> => {
    try {
        const emailExists = await schoolStore?.validateEmail(node.value as string);
        buttonIsDisabled.value = emailExists; // Disable button if email exists
        return !emailExists; // Validation passes if email does not exist
    } catch (error) {
        buttonIsDisabled.value = true; // Disable on error
        return true;
    }
};

const addChampion = () => {
    // Spread newAdmin to create a new instance and generate a unique _id
    newAdmins.value.push({
        ...newAdmin.value,
        _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
    });
};

const addSchoolGroupChampion = () => {
    // Spread newAdmin to create a new instance and generate a unique _id
    newSchoolGroupAdmins.value.push({
        ...newSchoolGroupAdmin.value,
        _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
    });
};

// Watch `selectedOption` to update `searchQuery` and bind to `schoolObject` country ID
watch(selectedOption, (newOption) => {
    searchQuery.value = newOption ? newOption.name : "";
    schoolObject.value.location.country = newOption?.id || "";
});

const clearData = () => {
    // Hide form fields
    showEditFields.value = false;

    // Clear the newAdmins array
    newAdmins.value = [];

    // Clear the schoolObject
    schoolObject.value = {
        name: "",
        domain: "",
        emisNumber: "",
        schoolGroup: "",
        academicYearStart: "",
        academicYearEnd: "",
        subjectsAvailable: "",
        preferredLang: "",
        location: {
            city: "",
            country: "",
            street: "",
        },
        admins: [],
        schoolGroupAdmins: [],
        schoolLicenseData: {
            type: 'annual',
            startDate: '',
            endDate: '',
            products: productStore.products.map(product => ({
                product: product._id,
                maxSeats: 0,
                seatsUsed: 0,
            }))
        } as NewLicenseFormData
    };

    //clear success message
    updateSuccess.value = false;

    //trying to clear the country value
    selectedOption.value = { id: "", name: "" };

    // Clear school Licenses
    schoolLicenses.value = {};
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormKit, {
              type: "form",
              class: "group-details-form",
              actions: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('internal_tools.school_group.group_details')), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('internal_tools.school_group.group_name'),
                    "outer-class": "primary-select primary-select-clear !grid",
                    "inner-class": "bg-white",
                    placeholder: _ctx.$t('internal_tools.school_group.type_here'),
                    modelValue: newSchoolGroup.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newSchoolGroup.value.name) = $event)),
                    "message-class": "absolute top-[28rem]",
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.school_group.group_name_validation')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('internal_tools.school_group.group_description'),
                    "outer-class": "primary-select primary-select-clear !grid",
                    "inner-class": "bg-white",
                    placeholder: _ctx.$t('internal_tools.school_group.type_here'),
                    modelValue: newSchoolGroup.value.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newSchoolGroup.value.description) = $event)),
                    "message-class": "absolute top-[28rem]",
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.school_group.group_description_validation')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("internal_tools.single_school_component.title")), 1),
            _hoisted_6,
            (schoolObject.value.schoolGroupAdmins.length > 0 && showEditFields.value == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolObject.value.schoolGroupAdmins, (admin, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: admin?._id,
                      class: "columns-5 mt-4 mb-2 relative"
                    }, [
                      _createVNode(_component_FormKit, {
                        type: "text",
                        label: _ctx.$t('internal_tools.form.champion_name'),
                        "outer-class": "primary-select",
                        placeholder: _ctx.$t('internal_tools.form.champion_name'),
                        modelValue: admin.firstName,
                        "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                        style: { position: 'relative' },
                        validation: "required",
                        "messages-class": 'absolute'
                      }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_FormKit, {
                        type: "text",
                        label: _ctx.$t('internal_tools.form.champion_surname'),
                        "outer-class": "primary-select",
                        placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                        modelValue: admin.lastName,
                        "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                        style: { position: 'relative' },
                        validation: "required",
                        "messages-class": 'absolute'
                      }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_FormKit, {
                        type: "email",
                        label: _ctx.$t('internal_tools.form.champion_email'),
                        "outer-class": "primary-select",
                        placeholder: _ctx.$t('internal_tools.form.champion_email'),
                        modelValue: admin.email,
                        "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                        validation: "required|email|(500)email_exists",
                        style: { position: 'relative' },
                        "validation-rules": { email_exists: email_exists },
                        "validation-messages": {
                            email_exists: _ctx.$t(
                                'add_grades_class_component.step_1.email_exists'
                            ),
                        },
                        "messages-class": 'absolute'
                      }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                      _createVNode(_component_FormKit, {
                        type: "text",
                        label: _ctx.$t('internal_tools.form.champion_title'),
                        "outer-class": "primary-select",
                        placeholder: _ctx.$t('internal_tools.form.champion_title'),
                        readonly: "",
                        classes: {
                            input: '!bg-gray-300 cursor-not-allowed'
                        },
                        modelValue: admin.designation,
                        "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                      }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_FormKit, {
                        type: "number",
                        label: _ctx.$t('internal_tools.form.champion_phone'),
                        "outer-class": "primary-select",
                        placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                        modelValue: admin.phoneNumber,
                        "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                      }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (removeSchoolGroupAdminAfterEdit(index)), ["prevent"]),
                          class: "mt-2 text-red-500"
                        }, [
                          _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                        ], 8, _hoisted_9)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(schoolStore).schoolStructureLoader === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(newSchoolGroupAdmins.value, (admin, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: admin._id,
                    class: "columns-5 mt-4 mb-2 relative"
                  }, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      label: _ctx.$t('internal_tools.form.champion_name'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_name'),
                      modelValue: admin.firstName,
                      "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                      style: { position: 'relative' },
                      validation: "required",
                      "messages-class": 'absolute'
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      label: _ctx.$t('internal_tools.form.champion_surname'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                      modelValue: admin.lastName,
                      "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                      style: { position: 'relative' },
                      validation: "required",
                      "messages-class": 'absolute'
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "email",
                      label: _ctx.$t('internal_tools.form.champion_email'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_email'),
                      modelValue: admin.email,
                      "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                      validation: "required|email|(500)email_exists",
                      style: { position: 'relative' },
                      "validation-rules": { email_exists: email_exists },
                      "validation-messages": {
                        email_exists: _ctx.$t(
                            'add_grades_class_component.step_1.email_exists'
                        ),
                    },
                      "messages-class": 'absolute'
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      label: _ctx.$t('internal_tools.form.champion_title'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_title'),
                      readonly: "",
                      classes: {
                        input: '!bg-gray-300 cursor-not-allowed'
                    },
                      modelValue: admin.designation,
                      "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      label: _ctx.$t('internal_tools.form.champion_phone'),
                      "outer-class": "primary-select",
                      placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                      modelValue: admin.phoneNumber,
                      "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                    }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (removeSchoolGroupChampion(index)), ["prevent"]),
                        class: "mt-2 text-red-500"
                      }, [
                        _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                      ], 8, _hoisted_12)
                    ])
                  ]))
                }), 128)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-gray-600",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (addSchoolGroupChampion()), ["prevent"]))
              }, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-plus',
                    title: 'rl plus',
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (previewStep())),
                type: "submit",
                class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-small-back-arrow',
                    title: 'rl small back arrow',
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (step.value = 2)),
                type: "submit",
                disabled: (newSchoolGroup.value.name.trim().length > 0 && newSchoolGroup.value.description.trim().length > 0) ? false : true,
                class: _normalizeClass('bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ' + ((newSchoolGroup.value.name.trim().length > 0 && newSchoolGroup.value.description.trim().length > 0) ? true : false ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'))
              }, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_next')), 11, _hoisted_18)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "form-card-tabs-container px-48",
            ref_key: "targetBlock",
            ref: targetBlock
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (step.value = 1)),
                type: "submit",
                class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
              }, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-small-back-arrow',
                    title: 'rl small back arrow',
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
              ])
            ]),
            _createVNode(_component_FormKit, {
              type: "form",
              id: "new-school-creation",
              actions: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('internal_tools.form.school_name'),
                    placeholder: _ctx.$t('internal_tools.form.school_name'),
                    modelValue: schoolObject.value.name,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schoolObject.value.name) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.school_name')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "select",
                    name: "subjects",
                    options: subjectsOptions.value,
                    label: _ctx.$t('internal_tools.form.subject'),
                    placeholder: _ctx.$t('internal_tools.form.select_subject'),
                    style: { color: 'text-gray-500', height: '3.5rem' },
                    modelValue: schoolObject.value.subjectsAvailable,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((schoolObject.value.subjectsAvailable) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.subject')}
                  }, null, 8, ["options", "label", "placeholder", "modelValue", "validation-messages"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('internal_tools.form.school_location'),
                    placeholder: _ctx.$t('internal_tools.form.school_location'),
                    modelValue: schoolObject.value.location.street,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schoolObject.value.location.street) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.school_location')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('internal_tools.form.domain_name'),
                    "outer-class": "primary-select ",
                    placeholder: _ctx.$t('internal_tools.form.domain_name'),
                    modelValue: schoolObject.value.domain,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schoolObject.value.domain) = $event)),
                    validation: [
                            ['required'],
                            [
                                'matches',
                                /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
                            ],
                        ],
                    "validation-messages": {
                            required:
                                _ctx.$t('internal_tools.add_school.domain_name'),
                            matches:
                                _ctx.$t('internal_tools.add_school.domain_example'),
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation", "validation-messages"])
                ]),
                _createElementVNode("div", {
                  class: "columns-2 mt-6 flex gap-4 items-end",
                  ref_key: "scrollUp",
                  ref: scrollUp
                }, [
                  _createVNode(_component_FormKit, {
                    class: "w-1/2",
                    type: "text",
                    label: _ctx.$t('internal_tools.form.city'),
                    "outer-class": "primary-select w-1/2",
                    placeholder: _ctx.$t('internal_tools.form.city_name'),
                    modelValue: schoolObject.value.location.city,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schoolObject.value.location.city) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.city_name')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
                  _createVNode(_unref(Combobox), {
                    class: "w-1/2 relative",
                    as: "div",
                    modelValue: selectedOption.value,
                    "onUpdate:modelValue": [
                      _cache[13] || (_cache[13] = ($event: any) => ((selectedOption).value = $event)),
                      _cache[14] || (_cache[14] = ($event: any) => (searchQuery.value = ''))
                    ],
                    label: _ctx.$t('internal_tools.form.city')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('internal_tools.form.country_title')), 1),
                      (showRequired.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t('internal_tools.add_school.couunty_name')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_unref(ComboboxInput), {
                          class: "w-full rounded-md border-0 bg-white py-[18px] pl-3 pr-10 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 font-normal text-base",
                          placeholder: placeholder.value,
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (searchQuery.value = $event.target.value)),
                          onBlur: _cache[12] || (_cache[12] = ($event: any) => (searchQuery.value = '')),
                          "display-value": () => formatCountryName(schoolObject.value.location.country) || '',
                          validation: "required"
                        }, null, 8, ["placeholder", "display-value"]),
                        _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ChevronUpDownIcon), {
                              class: "h-5 w-5 text-gray-400",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 1
                        }),
                        (filteredOptions.value.length > 0)
                          ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
                              key: 0,
                              class: "dropdown-options absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                                  return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                    key: option.id,
                                    value: option,
                                    as: "template"
                                  }, {
                                    default: _withCtx(({ active, selected }) => [
                                      _createElementVNode("li", {
                                        class: _normalizeClass([
                                        'relative cursor-default select-none py-2 pl-8 pr-4',
                                        active ? 'bg-indigo-600 text-white' : 'text-gray-900',
                                    ])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                        }, _toDisplayString(option.name), 3),
                                        selected
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass([
                                            'absolute inset-y-0 left-0 flex items-center pl-1.5',
                                            active ? 'text-white' : 'text-blue-600',
                                        ])
                                            }, [
                                              _createVNode(_unref(CheckIcon), {
                                                class: "h-5 w-5",
                                                "aria-hidden": "true"
                                              })
                                            ], 2))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"])
                ], 512),
                (wrongRegion.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_ctx.$t('internal_tools.region_guard.message', { belongs: wrongRegion.value.toUpperCase(), here: (here.value || '').toUpperCase() })) + " ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ml-2 font-semibold underline",
                        onClick: switchRegion
                      }, _toDisplayString(_ctx.$t('internal_tools.region_guard.switch')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_FormKit, {
                    type: "select",
                    name: "locale",
                    options: localeOptions.value,
                    label: _ctx.$t('internal_tools.form.language_title'),
                    placeholder: _ctx.$t('internal_tools.form.language'),
                    modelValue: schoolObject.value.preferredLang,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((schoolObject.value.preferredLang) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.language')
                        }
                  }, null, 8, ["options", "label", "placeholder", "modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: _ctx.$t('internal_tools.form.emis_number'),
                    placeholder: _ctx.$t('internal_tools.form.emis_number'),
                    modelValue: schoolObject.value.emisNumber,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((schoolObject.value.emisNumber) = $event))
                  }, null, 8, ["label", "placeholder", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_FormKit, {
                    type: "date",
                    label: _ctx.$t('internal_tools.form.start_month'),
                    placeholder: _ctx.$t('internal_tools.form.month'),
                    modelValue: schoolObject.value.academicYearStart,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((schoolObject.value.academicYearStart) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.start_date')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "date",
                    label: _ctx.$t('internal_tools.form.end_month'),
                    placeholder: _ctx.$t('internal_tools.form.month'),
                    modelValue: schoolObject.value.academicYearEnd,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((schoolObject.value.academicYearEnd) = $event)),
                    validation: "required",
                    "validation-messages": {
                            required: _ctx.$t('internal_tools.add_school.end_date')
                        }
                  }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_FormKit, {
                    type: "form",
                    actions: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_FormKit, {
                          type: "date",
                          name: "startDate",
                          modelValue: schoolObject.value.schoolLicenseData.startDate,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((schoolObject.value.schoolLicenseData.startDate) = $event)),
                          label: "New License Start Date",
                          placeholder: "Select Start Date",
                          validation: licenseStartDateValidationRule.value,
                          validationMessages: {
                                    required: 'Start date is required',
                                    date_after: 'Start date must be after today'
                                }
                        }, null, 8, ["modelValue", "validation"]),
                        _createVNode(_component_FormKit, {
                          type: "date",
                          name: "endDate",
                          label: "New License End Date",
                          placeholder: "Select End Date",
                          classes: { outer: 'col-span-2 w-full', inner: 'w-full', input: 'w-full' },
                          validation: `required|date_after_field:startDate`,
                          validationMessages: {
                                    required: 'End date is required',
                                    date_after: 'End date must be after start date',
                                },
                          modelValue: schoolObject.value.schoolLicenseData.endDate,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((schoolObject.value.schoolLicenseData.endDate) = $event))
                        }, null, 8, ["modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
                          return (_openBlock(), _createBlock(_component_FormKit, {
                            key: product._id,
                            type: "number",
                            name: `product_${product._id}`,
                            label: `${product.name} Seats`,
                            placeholder: "Enter number of seats",
                            validation: "required|min:0",
                            validationMessages: {
                                    required: 'Number of seats is required',
                                    min: 'At least 0 seat is required',
                                },
                            modelValue: schoolObject.value.schoolLicenseData.products.find((p) => p.product === product._id).maxSeats,
                            "onUpdate:modelValue": ($event: any) => ((schoolObject.value.schoolLicenseData.products.find((p) => p.product === product._id).maxSeats) = $event)
                          }, null, 8, ["name", "label", "modelValue", "onUpdate:modelValue"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("h1", _hoisted_33, _toDisplayString(_ctx.$t("internal_tools.form.add_champion")), 1),
                _hoisted_34,
                (schoolObject.value.admins.length > 0 && showEditFields.value == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolObject.value.admins, (admin, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: admin._id,
                          class: "columns-5 mt-4 mb-2 relative"
                        }, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: _ctx.$t('internal_tools.form.champion_name'),
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_name'),
                            modelValue: admin.firstName,
                            "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                            style: { position: 'relative' },
                            validation: "required",
                            "messages-class": 'absolute'
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: _ctx.$t('internal_tools.form.champion_surname'),
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                            modelValue: admin.lastName,
                            "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                            style: { position: 'relative' },
                            validation: "required",
                            "messages-class": 'absolute'
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "email",
                            label: _ctx.$t('internal_tools.form.champion_email'),
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_email'),
                            modelValue: admin.email,
                            "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                            validation: "required|email|(500)email_exists",
                            style: { position: 'relative' },
                            "validation-rules": { email_exists: email_exists },
                            "validation-messages": {
                                email_exists: _ctx.$t(
                                    'add_grades_class_component.step_1.email_exists'
                                ),
                            },
                            "messages-class": 'absolute'
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: _ctx.$t('internal_tools.form.champion_title'),
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_title'),
                            readonly: "",
                            classes: {
                                input: '!bg-gray-300 cursor-not-allowed'
                            },
                            modelValue: admin.designation,
                            "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "number",
                            label: _ctx.$t('internal_tools.form.champion_phone'),
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                            modelValue: admin.phoneNumber,
                            "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (removeChampionAfterEdit(index)), ["prevent"]),
                              class: "mt-2 text-red-500"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                            ], 8, _hoisted_37)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(schoolStore).schoolStructureLoader === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(newAdmins.value, (admin, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: admin._id,
                        class: "columns-5 mt-4 mb-2 relative"
                      }, [
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.champion_name'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.champion_name'),
                          modelValue: admin.firstName,
                          "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                          style: { position: 'relative' },
                          validation: "required",
                          "messages-class": 'absolute'
                        }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.champion_surname'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                          modelValue: admin.lastName,
                          "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                          style: { position: 'relative' },
                          validation: "required",
                          "messages-class": 'absolute'
                        }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "email",
                          label: _ctx.$t('internal_tools.form.champion_email'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.champion_email'),
                          modelValue: admin.email,
                          "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                          validation: "required|email|(500)email_exists",
                          style: { position: 'relative' },
                          "validation-rules": { email_exists: email_exists },
                          "validation-messages": {
                            email_exists: _ctx.$t(
                                'add_grades_class_component.step_1.email_exists'
                            ),
                        },
                          "messages-class": 'absolute'
                        }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.champion_title'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.champion_title'),
                          readonly: "",
                          classes: {
                            input: '!bg-gray-300 cursor-not-allowed'
                        },
                          modelValue: admin.designation,
                          "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                        }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "number",
                          label: _ctx.$t('internal_tools.form.champion_phone'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                          modelValue: admin.phoneNumber,
                          "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                        }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (removeChampion(index)), ["prevent"]),
                            class: "mt-2 text-red-500"
                          }, [
                            _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                          ], 8, _hoisted_40)
                        ])
                      ]))
                    }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-gray-600",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (addChampion()))
              }, [
                _createElementVNode("span", _hoisted_42, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-plus',
                    title: 'rl plus',
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("h1", _hoisted_43, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: _normalizeClass('px-[14px] py-[10px] text-white rounded-lg ' +
                    (_unref(adminStore).loader.creatingAdmin ||
                        _unref(schoolStore).updateLoader ||
                        buttonIsDisabled.value ||
                        schoolObject.value.name.trim() === '' ||
                        schoolObject.value.location.street.trim().length === 0 ||
                        schoolObject.value.location.country.trim().length === 0 ||
                        schoolObject.value.location.city.trim().length === 0 ||
                        schoolObject.value.domain.trim().length === 0 ||
                        schoolObject.value.subjectsAvailable.length === 0 ||
                        schoolObject.value.preferredLang.trim().length === 0 ||
                        schoolObject.value.academicYearStart.trim().length === 0 ||
                        schoolObject.value.academicYearEnd.trim().length === 0
                        ? 'cursor-not-allowed  !bg-blue-300 border-blue-300 !opacity-100'
                        : 'cursor-pointer bg-blue-600 border border-blue-600 ')
                    ),
                disabled: _unref(adminStore).loader.creatingAdmin ||
                        _unref(schoolStore).updateLoader ||
                        buttonIsDisabled.value ||
                        schoolObject.value.name.trim().length === 0 ||
                        schoolObject.value.location.street.trim().length === 0 ||
                        schoolObject.value.location.country.trim().length === 0 ||
                        schoolObject.value.location.city.trim().length === 0 ||
                        schoolObject.value.domain.trim().length === 0 ||
                        schoolObject.value.subjectsAvailable.length === 0 ||
                        schoolObject.value.preferredLang.trim().length === 0 ||
                        schoolObject.value.academicYearStart.trim().length === 0 ||
                        schoolObject.value.academicYearEnd.trim().length === 0,
                onClick: addSchoolToList
              }, [
                _createElementVNode("h1", _hoisted_46, [
                  (!showEditFields.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t("internal_tools.multiple_schools_component.add_school")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.$t("internal_tools.multiple_schools_component.update_school")), 1))
                ])
              ], 10, _hoisted_45)
            ]),
            (schoolsList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("h2", _hoisted_50, _toDisplayString(_ctx.$t('internal_tools.multiple_schools_component.schools')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolsList.value, (school, index) => {
                    return (_openBlock(), _createBlock(_component_FormKit, {
                      type: "form",
                      id: "new-school-creation",
                      actions: false,
                      key: school.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_FormKit, {
                              type: "text",
                              label: _ctx.$t('internal_tools.form.school_name'),
                              placeholder: _ctx.$t('internal_tools.form.school_name'),
                              value: school.name,
                              disabled: true
                            }, null, 8, ["label", "placeholder", "value"]),
                            _createVNode(_component_FormKit, {
                              type: "text",
                              label: 'Champion name',
                              "outer-class": "primary-select",
                              placeholder: 'No Champion',
                              modelValue: championNames.value[index],
                              "onUpdate:modelValue": ($event: any) => ((championNames.value[index]) = $event),
                              disabled: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (editSchool(index)), ["prevent"]),
                              class: "text-gray-600"
                            }, [
                              _createVNode(_unref(PencilIcon), { class: "h-5 w-5" })
                            ], 8, _hoisted_54),
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (showDeleteModal(index)), ["prevent"]),
                              class: "text-red-500"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                            ], 8, _hoisted_55)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(handleNext, ["prevent"]),
                      class: _normalizeClass('px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg '
                        )
                    }, [
                      _createElementVNode("h1", _hoisted_58, [
                        (
                                _unref(schoolStore).schoolCreationLoader || _unref(schoolGroupStore).schoolGroupLoader || _unref(adminStore).loader.creatingAdmin
                            )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                              _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.multiple_schools_component.create_school")), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t("internal_tools.form.btnSave")), 1))
                      ])
                    ], 8, _hoisted_57)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: isModalOpen.value,
      onLocalModalOpen: _cache[22] || (_cache[22] = ($event: any) => (isModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_rl_icon, {
                onClick: cancelDelete,
                class: "cursor-pointer",
                icon: 'rl-large-close',
                title: 'rl large close',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-exclamation-bg-logo',
                title: 'rl exclamation bg logo',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h1", _hoisted_66, _toDisplayString(_ctx.$t('internal_tools.multiple_schools_component.delete_message')), 1),
              _createElementVNode("p", _hoisted_67, _toDisplayString(schoolName.value), 1)
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("button", {
                onClick: cancelDelete,
                class: "shadow-box border border-gray-300 rounded-lg text-gray-700 text-sm font-semibold py-[10px] px-4 w-1/2"
              }, _toDisplayString(_ctx.$t('internal_tools.multiple_schools_component.btn_cancel')), 1),
              _createElementVNode("button", {
                onClick: confirmDelete,
                class: "shadow-box bg-red-500 rounded-lg text-white text-sm font-semibold py-[10px] px-4 w-1/2"
              }, _toDisplayString(_ctx.$t('internal_tools.multiple_schools_component.btn_delete')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})